(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produit-details"] && !Shopify.designMode) return;
  try {
    
// Le sélecteur de variante ne re-rend pas cette section : on suit le choix de
// couleur à la source, sur l'input coché, plutôt que d'attendre le serveur.
(function () {
  if (window.__pdCoin) return;
  window.__pdCoin = true;
  function suivre() {
    var choisi = document.querySelector(
      'input[type="radio"]:checked[name*="Couleur"], select[name*="Couleur"]');
    if (!choisi) return;
    var v = (choisi.value || '').trim().toLowerCase();
    if (v !== 'noir' && v !== 'blanc') return;
    document.querySelectorAll('.pd__img[data-couleur]').forEach(function (n) {
      n.setAttribute('data-couleur', v);
    });
  }
  document.addEventListener('change', suivre);
  document.addEventListener('click', function () { setTimeout(suivre, 60); });

  // Apparition au défilement. `pd--anim` n'est ajoutée QU'ICI : tant que ce
  // script n'a pas tourné, le CSS ne masque rien. Une section illisible coûte
  // plus cher qu'une animation manquante.
  function animer() {
    var racines = document.querySelectorAll('.pd');
    if (!racines.length || !('IntersectionObserver' in window)) return;
    racines.forEach(function (r) { r.classList.add('pd--anim'); });
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-vu');
        obs.unobserve(e.target);    // une seule fois : l'effet s'use s'il rejoue
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.pd__bloc').forEach(function (b) { obs.observe(b); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', animer);
  } else {
    animer();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
